import { defineMessages } from 'react-intl';

export const scope = 'loop.containers.Jobs';

export default defineMessages({
  Header: {
    id: `${scope}.header`,
    defaultMessage: 'Pronađi Posao',
  },
  Text: {
    id: `${scope}.text`,
    defaultMessage:
      'Budi u krugu najboljih poslovnih prilika na našem tržištu.',
  },
  More: {
    id: `${scope}.more`,
    defaultMessage: 'Vidi više...',
  },
  Less: {
    id: `${scope}.less`,
    defaultMessage: 'Vidi manje...',
  },
  Button: {
    id: `${scope}.button`,
    defaultMessage: 'Poslovi',
  },
  ChooseApplication: {
    id: `${scope}.chooseApplication`,
    defaultMessage: 'Prikaži poruke iz oglasa',
  },
  MessageSender: {
    id: `${scope}.messageSender`,
    defaultMessage: 'Poruku Poslao',
  },
  Reply: {
    id: `${scope}.reply`,
    defaultMessage: 'Odgovori',
  },
  Delete: {
    id: `${scope}.delete`,
    defaultMessage: 'Obriši',
  },
  JobSaved: {
    id: `${scope}.jobSaved`,
    defaultMessage: 'Oglas je sačuvan',
  },
  JobUnsaved: {
    id: `${scope}.jobUnsaved`,
    defaultMessage: 'Oglas je uklonjen',
  },
  JobsCategory: {
    id: `${scope}.jobsCategory`,
    defaultMessage: 'Poslovi po kategorijama',
  },
  AllCategories: {
    id: `${scope}.allCategories`,
    defaultMessage: 'Sve Kategorije',
  },
  InformationTechnology: {
    id: `${scope}.informationTechnology`,
    defaultMessage: 'Informacione tehnologije',
  },
  ProfessionalServices: {
    id: `${scope}.professionalServices`,
    defaultMessage: 'Profesionalne usluge',
  },
  Management: {
    id: `${scope}.management`,
    defaultMessage: 'Menadžment',
  },
  Tourism: {
    id: `${scope}.tourism`,
    defaultMessage: 'Turizam',
  },
  CraftAndServices: {
    id: `${scope}.craftAndServices`,
    defaultMessage: 'Zanatstvo i usluge',
  },
  Trade: {
    id: `${scope}.trade`,
    defaultMessage: 'Trgovina',
  },
  Other: {
    id: `${scope}.other`,
    defaultMessage: 'Ostalo',
  },
  SaveJob: {
    id: `${scope}.saveJob`,
    defaultMessage: 'Sačuvaj oglas',
  },
  ModalMessage: {
    id: `${scope}.modalMessage`,
    defaultMessage: 'Upravo si aplicirao/la na poziciju',
  },
  ModalMessageLong: {
    id: `${scope}.modalMessageLong`,
    defaultMessage:
      'loop garantuje predstavljanje tvoje prijave poslodavcu i osigurava bezbednost tvojih podataka u procesu konkurisanja.',
  },
  ModalMessageLong2: {
    id: `${scope}.modalMessageLong2`,
    defaultMessage:
      'Želimo ti puno sreće u ovom konkursu, a za više pitanja budi slobodan/a da nas kontaktiraš.',
  },
  ApplyingForPosition: {
    id: `${scope}.applyingForPosition`,
    defaultMessage: 'Apliciraš za poziciju',
  },
  Apply: {
    id: `${scope}.apply`,
    defaultMessage: 'Apliciraj',
  },
  Cv: {
    id: `${scope}.cv`,
    defaultMessage: 'Zakači CV',
  },
  CoverLetter: {
    id: `${scope}.coverLetter`,
    defaultMessage: 'Zakači motivaciono pismo',
  },
  AddCV: {
    id: `${scope}.addCv`,
    defaultMessage: 'DODAJ CV',
  },
  AddCoverLetter: {
    id: `${scope}.addCoverLetter`,
    defaultMessage: 'DODAJ MOTIVACIONO PISMO',
  },
  AdditionalComment: {
    id: `${scope}.additionalComment`,
    defaultMessage: 'Dodatni komentar',
  },
  LoginMessage: {
    id: `${scope}.loginMessage`,
    defaultMessage: 'Molimo vas ulogujte se pa probajte ponovo.',
  },
  MustBeLogged: {
    id: `${scope}.mustBeLogged`,
    defaultMessage: 'Moraš biti ulogovan/a da bi aplicirao/la za poziciju.',
  },
  IfYouHaveAccount: {
    id: `${scope}.ifYouHaveAccount`,
    defaultMessage: 'Ukoliko već imaš nalog, prijavi se.',
  },
  IfYouDontHaveAccount: {
    id: `${scope}.ifYouDontHaveAccount`,
    defaultMessage: 'Ukoliko nemaš nalog, registruj se.',
  },
  ActiveJobs: {
    id: `${scope}.activeJobs`,
    defaultMessage: 'Oglasi u toku',
  },
  SignUp: {
    id: `${scope}.signUp`,
    defaultMessage: 'Prijavi se',
  },
  JobAdPlace: {
    id: `${scope}.jobAdPlace`,
    defaultMessage: 'Primaj ponude poslova na e-mail',
  },
  Published: {
    id: `${scope}.published`,
    defaultMessage: 'Oglas postavljen',
  },
  expired: {
    id: `${scope}.expired`,
    defaultMessage: 'Oglas ističe',
  },
  Salary: {
    id: `${scope}.salary`,
    defaultMessage: 'Plata',
  },
  updateCV: {
    id: `${scope}.updateCV`,
    defaultMessage: 'Zameni',
  },
  LeaveLoopText: {
    id: `${scope}.leaveLoopText`,
    defaultMessage: 'Upravo napuštaš loop kako bi aplicirao na',
  },
  Position: {
    id: `${scope}.position`,
    defaultMessage: 'poziciju.',
  },
  Responsibility: {
    id: `${scope}.responsibility`,
    defaultMessage:
      'Odgovornost za dalju obradu i bezbednost tvojih podataka preuzima poslodavac koji je oglasio poziciju.',
  },
  GoodLuck: {
    id: `${scope}.goodLuck`,
    defaultMessage: 'Srećno!',
  },
  LeaveSite: {
    id: `${scope}.leaveSite`,
    defaultMessage: 'Napusti sajt',
  },
  UploadNotification: {
    id: `${scope}.uploadNotification`,
    defaultMessage:
      'Zakači dokumenta (CV i motivaciono pismo) u <b>PDF formatu</b> koja ćeš koristiti u većini slučajeva kada apliciraš. Ukoliko nemaš dokumenta u ovom formatu, možeš koristiti dostupne online konvertore poput ',
  },
  AlreadyApplied: {
    id: `${scope}.alreadyApplied`,
    defaultMessage: 'Već si se prijavio/la na ovaj oglas',
  },
  ChooseLocation: {
    id: `${scope}.chooseLocation`,
    defaultMessage: 'Izaberi jednu ili više lokacija koje ti odgovaraju za rad',
  },
});
